export default "__VITE_ASSET__CrTHKqg7__"